/**
 * Combsol Label-Line — Spec §2.3
 * Display 700 .8rem UPPERCASE, 1px-Unterstrich in border-grey.
 * Verwendung: Form-Labels, Stat-Keys, Meta-Überschriften.
 */
import type { CSSProperties, ReactNode } from "react";

interface Props {
  children: ReactNode;
  dark?: boolean;
  className?: string;
  style?: CSSProperties;
  as?: "span" | "div" | "label";
  htmlFor?: string;
}

export function LabelLine({ children, dark = false, className = "", style, as = "span", htmlFor }: Props) {
  const Tag = as as any;
  const color = dark ? "var(--color-brand-navy, #002D72)" : "var(--color-foreground, #1A1D22)";
  return (
    <Tag
      className={className}
      htmlFor={htmlFor}
      style={{
        display: "inline-block",
        fontFamily: "var(--font-display, 'Montserrat', sans-serif)",
        fontWeight: 600,
        fontSize: "0.75rem",
        textTransform: "uppercase",
        letterSpacing: "0.1em",
        color,
        paddingBottom: 6,
        borderBottom: "1px solid var(--border-grey, #C6C6C6)",
        ...style,
      }}
    >
      {children}
    </Tag>
  );
}
